module.exports = __webpack_public_path__ + "471ecdd643fb9aba879ffefe3f41ae39.svg";